import { connect } from 'react-redux';
import SearcherFixedButton from '../../components/Searcher/SearcherFixedButton';
import { showPageAction } from '../../store/actions/view';
import { HOTEL_MOBILE_PAGES } from '../../constants';
import { getPrice, getSearchedNights } from '../../store/selectors/common';
import {
  getSearcherFetching,
  getSearcherTouristsCount,
} from '../../store/selectors/searcher';

const mapStateToProps = (state) => ({
  fetching: getSearcherFetching(state),
  price: getPrice(state),
  nightsCount: getSearchedNights(state),
  touristsCount: getSearcherTouristsCount(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(showPageAction(HOTEL_MOBILE_PAGES.SEARCHER)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearcherFixedButton);
